import React from 'react';
export var ArrowIconDirection;
(function (ArrowIconDirection) {
    ArrowIconDirection[ArrowIconDirection["UP"] = 90] = "UP";
    ArrowIconDirection[ArrowIconDirection["DOWN"] = -90] = "DOWN";
    ArrowIconDirection[ArrowIconDirection["LEFT"] = 0] = "LEFT";
    ArrowIconDirection[ArrowIconDirection["RIGHT"] = 180] = "RIGHT";
})(ArrowIconDirection || (ArrowIconDirection = {}));
const ArrowIcon = ({ orientation, disabled = false, ...rest }) => {
    const styles = {
        svg: {
            transform: `rotate(${orientation}deg)`,
        },
        path: {
            opacity: disabled ? '50%' : '100%',
        },
    };
    return (React.createElement("svg", { style: styles.svg, width: "24", height: "24", viewBox: "0 0 24 24", fill: "#6E6764", xmlns: "http://www.w3.org/2000/svg", ...rest },
        React.createElement("g", { id: "arrow-left" },
            React.createElement("path", { style: styles.path, id: "Vector", d: "M20.0002 11V13H8.00016L13.5002 18.5L12.0802 19.92L4.16016 12L12.0802 4.08002L13.5002 5.50002L8.00016 11H20.0002Z" }))));
};
export default ArrowIcon;
